import React from 'react'
import moment from 'moment'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import { Form, Grid, Header, Icon, Button } from 'semantic-ui-react'
import { FormValidation, Field } from '../components'
import { fields } from '../../common/lib/redux-fields'
import { createUser, updateUser } from '../../common/users/actions'
import { loadCompanies, clearCompanies } from '../../common/companies/actions'
import {
  validateCreate,
  validateUpdate,
} from '../../common/users/validations'
import { assignableRoles, roles } from '../../common/config'

const { Row, Column } = Grid

const roleOptions = Object.keys(assignableRoles).filter(k => !!k).map(key => ({
  value: key,
  text: assignableRoles[key],
}))

class UserForm extends React.Component {
  componentWillMount() {
    const { loadCompanies } = this.props
    loadCompanies({ sort: 'nameSort' })
  }

  componentWillUnmount() {
    this.props.fields.$reset()
    this.props.clearCompanies()
  }

  async submit(e) {
    e.preventDefault()
    const { fields, submit, user, createUser, updateUser } = this.props
    const isUpdate = user && !!user._id
    const values = fields.$values()
    let submissionFunction = createUser

    if (isUpdate) {
      values._id = user._id
      submissionFunction = updateUser
    }

    await submit(values, submissionFunction)
  }

  render() {
    const {
      fields,
      errors,
      companyOptions,
      submitting,
      submitSuccessfull,
      errorMessage,
      user,
      viewer,
      redirect,
    } = this.props

    if (submitSuccessfull && redirect) return <Redirect to="/users" />

    const fieldData = Object.assign({}, fields)
    errors.forEach(error => {
      if (error.detail && error.detail.field && fieldData[error.detail.field]) {
        fieldData[error.detail.field].error = error.message
      }
    })

    const editable = viewer.role === 'SUPERVISOR' || (viewer.role === 'ADMIN' && user && user._id !== viewer._id)

    if (!editable) {
      const disabledFields = ['role', 'company', 'canCreateAttendance']
      disabledFields.forEach((field) => { fieldData[field].disabled = true })
    }

    return (
      <Form loading={submitting} size="big">
        <Grid>
          <Row>
            <Column>
              <Header as="h2">Základní údaje</Header>
            </Column>
          </Row>
          <Field label="Jméno" {...fieldData.firstName} required />
          <Field label="Příjmení" {...fieldData.lastName} required />
          <Field type="email" label="Email" {...fieldData.email} required />
          <Field type="select" label="Role" {...fieldData.role} options={[].concat(roleOptions)} />
          {fields.role.value === roles.FLEET_MANAGER &&
            <Field label="Dopravce" type="select" {...fieldData.company} options={companyOptions} />
          }
          {fields.role.value === roles.INSTRUCTOR &&
            <Field type="checkbox" label="Vytváří prezenční listiny" {...fieldData.canCreateAttendance} />
          }
        </Grid>

		{editable &&
        <Grid>
          <Row>
            <Column>
              <Header as="h2">Stav</Header>
            </Column>
          </Row>
          {user && !user.archivedAt &&
          <Field type="checkbox" label="Neaktivní uživatel" {...fieldData.markNotActive} />
          }
          {user && user.archivedAt &&
          <Field type="checkbox" label="Aktivní uživatel" {...fieldData.markActive} />
		  }
		  {user && user.archivedAt &&
          <Row columns={2}>
            <Column><Icon color="red" name="remove user" /> Vyřazen:</Column>
            <Column>{moment(user.archivedAt).format('D.M.YYYY HH:mm')}</Column>
          </Row>
          }
        </Grid>
		}

        <Grid>
          <Row>
            <Column>
              <Header as="h2">
                {user ? 'Změna hesla' : 'Heslo'}
              </Header>
            </Column>
          </Row>
          <Field type="password" label={user ? 'Nové heslo' : 'Heslo'} {...fieldData.password} />
          <Field type="password" label={user ? 'Zopakujte nové heslo' : 'Zopakujte heslo'} {...fieldData.passwordConfirmation} />
        </Grid>

        {errorMessage}

        <Grid>
          <Row>
            <Column>
              <Button type="submit" onClick={(e) => this.submit(e)}>Uložit</Button>
            </Column>
          </Row>
        </Grid>
      </Form>
    )
  }
}

UserForm.defaultProps = {
  user: null,
  errors: [],
  submitting: false,
  submitSuccessfull: false,
  redirect: true,
}

UserForm.propTypes = {
  fields: React.PropTypes.object.isRequired,
  viewer: React.PropTypes.object.isRequired,
  user: React.PropTypes.object,
  errors: React.PropTypes.array,
  companyOptions: React.PropTypes.array.isRequired,
  loadCompanies: React.PropTypes.func.isRequired,
  clearCompanies: React.PropTypes.func.isRequired,
  submitting: React.PropTypes.bool,
  submitSuccessfull: React.PropTypes.bool,
  errorMessage: React.PropTypes.any,
  redirect: React.PropTypes.bool,
}

UserForm = fields(UserForm, {
  path: 'UserForm',
  fields: [
    'firstName', 'lastName', 'email', 'role',
    'password', 'passwordConfirmation', 'company',
    'canCreateAttendance','markNotActive', 'markActive'
  ],
  getInitialState: (props) => {
    const { user } = props
    if (user && user._id) return user.toJS()
    return { role: 'INSTRUCTOR', canCreateAttendance: false, markActive: false, markNotActive: false }
  },
})

UserForm = FormValidation(UserForm, (props) => {
  const { user } = props
  let submissionValidation
  if (user && user._id) submissionValidation = validateUpdate
  else submissionValidation = validateCreate
  return { submissionValidation }
})

export default connect(state => ({
  viewer: state.users.viewer,
  companyOptions: state.companies.all.map(c => ({ value: c._id, text: c.name })).toArray(),
}), { createUser, updateUser, loadCompanies, clearCompanies })(UserForm)



// WEBPACK FOOTER //
// ./src/browser/forms/User.js